
import axios from 'axios';

import { store , defineListControllers  } from "../state/redux";

export const  axios_contrats_createcontrat = async (contrat)=>{
    return await axios.post(`/contrats/createcontrat`,contrat,{headers:{'Accept':'application/json','Content-Type':'application/json'}});
}

export const  axios_contrats_updatecontrat= async (contrat)=>{
    return await axios.post(`/contrats/updatecontrat/`,contrat);
}

// DEV 
export const  axios_contrats_updatestatutcontrat= async ({id_contrat,newstatut})=>{
    return await axios.post(`/contrats/updatestatutcontrat/`,{id_contrat,newstatut});
}

export const  axios_contrats_maintiencontrat= async (email)=>{
    return await axios.post(`/contrats/maintiencontrat/`,{email});
}

export const  axios_contrats_getcontratsbyemail= async (email,courtier)=>{
    const controller = new AbortController();
    const actucontrollers = store.getState().formules.listcontrollers ;
    store.dispatch(defineListControllers([...actucontrollers,controller]))  ;
    return await axios.post(`/contrats/getcontratsbyemail/`,{email,courtier},{signal: controller.signal},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
}

export const  axios_contrats_deletecontrat= async (indexe)=>{
    return await axios.post(`/contrats/deletecontrat/`,{indexe},{headers:{'Accept':'application/json','Content-Type':'application/json'}}) ;
}


export const  axios_contrats_getall= async ({debut,fin})=>{
    return await axios.post(`/contrats/getall/`,{debut,fin},{headers:{'Accept':'application/json','Content-Type':'application/json',} }) ;  //  'Authorization': `Bearer ${localStorage.getItem('token')}`
}


export const  axios_contrats_search= async (data)=>{
    return await axios.post(`/contrats/search/`,{data},{headers:{'Accept':'application/json','Content-Type':'application/json'} }) ; // 
}
